<div [ngClass]="allAccess && loggedUserRole == 4 ?  'filtersContainerOutlet' : 'filtersContainer'">
    <div class="col-md-2 filter-btn" appShowHide style="display: contents;">
        <button type="button" class="btn-filter" data-toggle="collapse" data-target="#filterCollapseInt"
            aria-expanded="false" aria-controls="collapseExample" (click)="refreshFilters()">
            <img src="../../../../../assets/icons/filter.png" id="navitem" width="16px" height="16px" alt=""
                loading="lazy" style="margin: 0px 5px ;">
            Filters
        </button>
    </div>
    <div class="col-md-10" style="display: flex; justify-content: flex-end;" appCanAccess [accessPolicy]="[12]">
        <div (click)="addIntClick()" data-toggle="modal" data-target="#integrationModal"
            style="display: flex; justify-content: center; align-items: center; color: white; height: 42px; width: 182px; background-color: #2D5697; 
                border-radius: 5px; text-align: center; cursor: pointer;   font-weight: 400; font-size: 14px !important;">
            Add Integration
        </div>
    </div>
</div>

<div class="collapse" id="filterCollapseInt">
    <div class="filterCol">
        <form [formGroup]="filterForm" id="filterForm">
            <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'filtersBox' : 'filtersBoxAdmin' ">
                <label class="filterLbl" for="menuName">Admin Filters</label>
                <div class="row filtersRow">
                    <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                        <label class="lblInput" for="menuName">Franchise</label>
                        <div class="filterInput">
                            <select class='form-control bulkInput selectpicker' id="spicker_franchise_int"
                                (ngModelChange)="selectFranchiseFilter($event)" formControlName="franchise"
                                data-style="dropdownCustomStyle">
                                <option selected value='' disabled
                                    data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                    {{franchise.name}} </option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label class="lblInput" for="menuName">Outlet</label>
                        <div class="filterInput2">
                            <select class='form-control bulkInput selectpicker' id="spicker_shop1"
                                formControlName="shop" (ngModelChange)="selectFilterShop($event)"
                                data-style="dropdownCustomStyle" disabled>
                                <option selected value='' disabled
                                    data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                <option *ngFor="let shop of shopsFilter" [ngValue]="shop">
                                    {{shop.name}} </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>
<div *ngIf="!isDataLoadedUser" class="item">
    <ngx-skeleton-loader class="skelton-tiles" count="1" [theme]="{ 
    'border-radius': '0px',
    height: '100px','margin-top':'20px'
  }"></ngx-skeleton-loader>
</div>
<div *ngIf="isDataLoadedUser">
    <app-table [isDataLoaded]="isDataLoadedUser" [tableData]="integratedPlatforms" [tableInfo]="tableInfo"
        [filterSearchAvailability]="filterSearchAvailability" (searchItems)="searchItems($event)"
        [placeholderText]="placeholderText" [tableConfig]="tableConfig" [tableAction]="tableAction"
        [filterClickHeight]="39" [filterNotClickHeight]="57" (onEditClick)="onEditClicked($event)"
        (onDeleteClick)="open_deleteItemModal($event)" [noItemsAvailable]="noItemsAvailable"
        [filterAvailability]="filterAvailability" [isFilterClicked]="isFilterClicked" [policies]="[12]"
        (getMoreItems)="getMorePages($event)" [currentPage]="currentPage" [pages]="pages"
        [visiblePages]="visiblePages"></app-table>
</div>

<!-- Modal -->
<div class="modal fade" id="integrationModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius: 16px !important;">
            <form [formGroup]="deliveryPlatformForm">
                <div class="modal-body">
                    <div class="row modal-heading-row">
                        <div class="row heading-row-right">
                            <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                                class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                            <div class="modal-Heading" *ngIf="fromadd">
                                Add Integration
                            </div>
                            <div class="modal-Heading" *ngIf="!fromadd">
                                Edit Integration
                            </div>
                        </div>
                        <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                            style="cursor: pointer; " class="d-inline-block align-top" alt="" loading="lazy"
                            data-dismiss="modal" (click)="onCancelModal()">
                    </div>
                    <hr>


                    <div style="display: flex; justify-content: space-between;">
                        <div>
                            <div style="font-size: 14px;">
                                Integration ID
                            </div>
                            <div *ngIf="!fromadd"
                                style="margin-top: 15px; font-size: 24px; font-weight: 800; height: 32px;">
                                {{intId}}
                            </div>
                        </div>
                        <div>
                            <div style="font-size: 14px;">
                                Is this integration need an upload function?
                            </div>
                            <div
                                style="margin-top: 15px; font-size: 14px; display: flex; align-items: center;  height: 32px;">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="can_upload" id="exampleRadios1"
                                        [(ngModel)]="can_upload" value=1 formControlName="can_upload" checked>
                                    <label class="form-check-label" for="exampleRadios1"> Yes </label>
                                </div>
                                <div class="form-check" style="margin-left: 25px;">
                                    <input class="form-check-input" type="radio" name="can_upload" id="exampleRadios2"
                                        [(ngModel)]="can_upload" value=0 formControlName="can_upload" [checked]="true">
                                    <label class="form-check-label" for="exampleRadios2"> No</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Integration Name</label><span
                                    style="color: #DC4A4A;">*</span>
                                <input type="text" style=" font-size: 14px;" class="form-control input"
                                    aria-describedby="emailHelp" formControlName="name" placeholder="Name Here">
                            </div>
                        </div>
                    </div>

                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">API Url</label><span style="color: #DC4A4A;">*</span>
                                <input type="text" style=" font-size: 14px;" class="form-control input"
                                    formControlName="api_url" aria-describedby="emailHelp" placeholder="API Url Here">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Type</label><span style="color: #DC4A4A;">*</span>
                                    <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect3"
                                        formControlName="is_master" (ngModelChange)="selectType($event)">
                                        <option value='' selected>Choose a Type...</option>
                                        <option *ngFor="let type of types; let i = index" value={{type.id}}>
                                            {{type.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;" *ngIf="df.is_master.value == 0">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Master</label><span style="color: #DC4A4A;">*</span>
                                    <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect3"
                                        formControlName="parent_platform">
                                        <option value='' selected>Choose a Type...</option>
                                        <option *ngFor="let master of masterTypes; let i = index" value={{master.id}}>
                                            {{master.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Brand</label><span style="color: #DC4A4A;">*</span>
                                    <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect4"
                                        formControlName="webshop_brand_id">
                                        <option value='' selected>Choose a Type...</option>
                                        <option *ngFor="let brand of brands; let i = index" value={{brand.id}}>
                                            {{brand.brand_name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div [ngClass]="!fromadd ? 'displayShopData' : 'hideShopData'">
                        <div>
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Franchise</label><span
                                        style="color: #DC4A4A;">*</span>
                                    <input type="text" style=" font-size: 14px;" class="form-control input" disabled
                                        formControlName="franchiseName" aria-describedby="emailHelp">
                                </div>
                            </div>
                        </div>

                        <div>
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Outlet</label><span style="color: #DC4A4A;">*</span>
                                    <input type="text" style=" font-size: 14px;" class="form-control input" disabled
                                        formControlName="outletName" aria-describedby="emailHelp">
                                </div>
                            </div>
                        </div>

                    </div>

                    <div [ngClass]="fromadd ? 'displayShopData' : 'hideShopData'">
                        <div class="input-twin">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1" class="lblInput">Franchise</label><span
                                        style="color: red;">*</span>
                                    <select class='form-control bulkInput selectpicker' id="spicker_franchise_int2"
                                        formControlName="franchise_id" data-style="dropdownCustomStyle"
                                        (ngModelChange)="selectFranchise($event)" data-live-search="true">
                                        <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                            {{franchise.name}} </option>

                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="input-twin">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1" class="lblInput">Outlet</label><span
                                        style="color: red;">*</span>
                                    <select class='form-control bulkInput selectpicker' id="spicker_shop_int2"
                                        (ngModelChange)="selectShop($event)" formControlName="outlet_id"
                                        data-style="dropdownCustomStyle" data-live-search="true" disabled>
                                        <option *ngFor="let shop of shops" [ngValue]="shop.id">
                                            {{shop.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Store Id</label><span style="color: #DC4A4A;">*</span>
                                <input type="text" style=" font-size: 14px;" class="form-control input"
                                    formControlName="outlet_code" aria-describedby="emailHelp"
                                    placeholder="Store Id Here">
                            </div>
                        </div>
                    </div>

                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Platform Type</label><span
                                    style="color: #DC4A4A;">*</span>
                                <select ng-disabled="!fromadd" (change)="onTypeChange($event.target.value)"
                                    class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect2"
                                    formControlName="platform_id">
                                    <option value='' selected>Choose...</option>
                                    <option *ngFor="let platform of deliveryPlatforms; let i = index"
                                        value={{platform.id}}>
                                        {{platform.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div formGroupName="api_parameters">

                        <div *ngFor="let para of intFeild">
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">{{para | titlecase}}</label><span
                                        style="color: #DC4A4A;">*</span>
                                    <input formControlName={{para}} type="text" style=" font-size: 14px;"
                                        class="form-control input" aria-describedby="emailHelp"
                                        placeholder='{{para}} Here'>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Logo Url</label><span style="color: #DC4A4A;">*</span>
                                <input type="text" style=" font-size: 14px;" class="form-control input"
                                    formControlName="logo" aria-describedby="emailHelp" placeholder="Logo Url Here">
                            </div>
                        </div>
                    </div>
                    <!-- <div *ngIf="deliveryPlatformForm.controls['platform_id'].value == 2">
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Username</label>
                                <input type="text" style=" font-size: 14px;" class="form-control input"
                                    formControlName="username" aria-describedby="emailHelp" placeholder="Username Here">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="deliveryPlatformForm.controls['platform_id'].value == 2">
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Password</label>
                                <input type="text" style=" font-size: 14px;" class="form-control input"
                                    formControlName="password" aria-describedby="emailHelp" placeholder="Password Here">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="deliveryPlatformForm.controls['platform_id'].value == 2">
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group-toggle">
                                <label for="exampleInputEmail1">Uber Dusk Availability</label>
                                <ui-switch size="small" switchColor="white" color="#00c10b" defaultBgColor="white"
                                    uncheckedLabel="Off" checkedLabel="On" checkedTextColor="white"
                                    defaultBoColor="#cccccc" (valueChange)="updateSwitch($event)"
                                    [(ngModel)]="selectUberDusk" [ngModelOptions]="{standalone: true}">
                                </ui-switch>
                            </div>
                        </div>
                    </div> -->
                    <div style="display: flex; justify-content: space-between;">
                        <div style="width: 45%;">
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Primary Color</label>
                                    <input type="color" style=" font-size: 14px;" class="form-control input"
                                        formControlName="primary_color" aria-describedby="emailHelp"
                                        placeholder="Color Value Here Ex #FFFFFF" value="#ffffff">
                                </div>
                            </div>
                        </div>

                        <div style="width: 45%;">
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Status</label><span style="color: #DC4A4A;">*</span>
                                    <select (change)="onStatusChange($event.target.value)" class="custom-select mr-sm-2"
                                        formControlName="status" style=" font-size: 14px;" id="inlineFormCustomSelect">
                                        <option value='' selected>Choose...</option>
                                        <option>Active</option>
                                        <option>Inactive</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p *ngIf="intFormInVaild" style="font-size: 14px;" class="alert alert-danger">
                        Please fill the required fields!
                    </p>
                    <p *ngIf="message != ''  && !intSucess" class="alert alert-danger">{{message}}</p>
                    <p *ngIf="message != ''  &&  intSucess" class="alert alert-success">{{message}}</p>


                    <div style="display: flex; justify-content: space-between; margin : 25px 0px">
                        <div (click)="onCancelModal()" data-dismiss="modal" class="btn-cancel"
                            style=" display: flex; justify-content: center; align-items: center; cursor: pointer;">
                            Cancel
                        </div>

                        <div (click)="fromadd ? addIntegration() : editIntegration() " class="btn-action"
                            style=" display: flex; justify-content: center; align-items: center; cursor: pointer;">
                            <span *ngIf="fromadd && !loaderSpin"> Add Integration</span>
                            <span *ngIf="!fromadd  && !loaderSpin"> Save Integration</span>

                            <div *ngIf="loaderSpin" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>

                        </div>
                    </div>

                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<app-delete-modal modelId="{{modelId}}" modalName="Integration" title={{selectedIntegrationName}}
    (deleteItem)="deleteOutlet()" [loading]="loaderSpin"></app-delete-modal>